import { isFeatureEnabled } from 'owa-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { isGulpOrBranching } from 'owa-config';
import type { OfflineDisabledReason } from './OfflineDisabledReason';
import { getCurrentLanguageFromCurrentLocale } from 'owa-localize';

export function isOfflineSyncAvailable(): boolean {
    return getOfflineSyncUnavailableReason() === undefined;
}

export function getOfflineSyncUnavailableReason(): OfflineDisabledReason | undefined {
    /* eslint-disable-next-line no-restricted-properties -- (https://aka.ms/OWALintWiki)
     * need to use indexedDB.databases to workaround Dexie version handling */
    if (!self.BroadcastChannel || !self.indexedDB?.databases) {
        return 'LegacyBrowser';
    }

    if (!isAnyOfflineModuleEnabled()) {
        return 'FeatureFlags';
    }

    const language = getCurrentLanguageFromCurrentLocale();
    if (language === 'tr') {
        // Turkish is (temporarily) not supported for offline sync due to a bug in the OWS server.
        // See https://o365exchange.visualstudio.com/O365%20Core/_git/Substrate/pullrequest/4281032
        return 'CultureNotSupported';
    }

    return getOfflineSyncUnavailableReasonDueToPolicy();
}

export function getOfflineSyncUnavailableReasonDueToPolicy(): OfflineDisabledReason | undefined {
    const policies = getUserConfiguration().PolicySettings;

    /*
    offlineDataAllowed is only enabled for native
    localCacheAllowed is only enabled for web
    */
    if (isHostAppFeatureEnabled('offlineDataAllowed')) {
        return !policies?.OfflineEnabledWin ? 'Policy' : undefined;
    }

    if (isHostAppFeatureEnabled('localCacheAllowed')) {
        if (isGulpOrBranching()) {
            return undefined;
        }

        if (!policies?.OfflineEnabledWeb) {
            return 'Policy';
        }

        if (!policies?.SignInState?.includes('kmsi')) {
            return 'DataNotAllowed';
        }

        return undefined;
    }

    return 'DataNotAllowed';
}

function isAnyOfflineModuleEnabled() {
    return (
        isFeatureEnabled('fwk-offline-mail') ||
        isFeatureEnabled('fwk-offline-calendar') ||
        isFeatureEnabled('peo-offline') ||
        isFeatureEnabled('peo-offline-via-pdv') ||
        isFeatureEnabled('peo-offline-shadow-pdv') ||
        isFeatureEnabled('msplaces-offline')
    );
}
